import { Component, Input } from '@angular/core';
import { IStyleOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { ITableOfContentEntry } from '../../../interfaces/table-of-content-entry.interface';
import { localizationKeys } from '../../../utils/localizationKeys';

@Component({
    selector: 'aumico-annual-report-toc-display',
    templateUrl: 'toc.display.component.html',
    styleUrls: ['toc.display.component.scss'],
})
export class AnnualReportTocDisplayComponent {
    public readonly tableOfContentTitleKey = localizationKeys.aumico_reports_annualreport_toc_label_table_of_contents;

    @Input()
    contentItems: ITableOfContentEntry[] = [];

    titleColor: string;
    textColor: string;
    tableFooterColor: string;
    tableHeaderColor: string;
    @Input() set stylePreferenceOptions(value: IStyleOptions) {
        if (value != null) {
            this.textColor = value.textColor;
            this.titleColor = value.titleColor;
            this.tableHeaderColor = value.tableHeaderColor;
            this.tableFooterColor = value.tableFooterColor;
        }
    }

    @Input() activeLocale: string;
}
